import { useEffect, useRef, useState } from "react";
import TabItems from "@/components/molecules/TabItems";
import TabContent from "@/components/organisms/TabContent";
import DropdownTabs from "@/components/molecules/DropdownTabs";
import CounterTabs from "@/components/molecules/CounterTabs";
import classNames from "classnames";
import arrowimage from "@/public/images/icons/down-arrow.svg";
import prev from "@/public/images/icons/prev.svg";
import next from "@/public/images/icons/next.svg";
import TabSlider from "@/components/molecules/TabSlider";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination } from "swiper";

const TabsSlider = ({
  tabs = [],
  classes,
  type = "select",
  arrow = arrowimage,
  counter = true,
  arrowPrev = prev,
  arrowNext = next,
  arrowPrevSlider = prev,
  arrowNextSlider = next,
}) => {
  const sliderRef = useRef();
  const [active, setActive] = useState(0);
  const onSelect = (key) => {
    setActive(key);
  };
  const onChange = (action) => {
    switch (action) {
      case "prev":
        if (active > 0) {
          setActive(active - 1);
        }
        break;
      case "next":
        if (active < tabs.length - 1) {
          setActive(active + 1);
        }
        break;
      default:
    }
  };
  useEffect(() => {
    setActive(0);
  }, [tabs]);
  useEffect(() => {
    sliderRef.current.swiper.slideTo(active);
  }, [active]);

  const styles = {
    container:
      classes?.container ||
      "base-container base-grid gap-0 px-0 md:px-3 relative ",
    tabs: classes?.tabs || {
      inactive: " text-medium-grey  hover:text-main-blue-king  lg:mx-3 ",
      tab: "font-subtitle text-base uppercase px-3 ",
    },
    tabsItemsContainer:
      classes?.tabsItemsContainer ||
      "col-span-12 md:col-span-10 md:col-start-2  py-4 px-3 md:px-0",
    tabContent: classes?.tabContent || {
      paragraphsContainer:
        "col-span-12 lg:col-span-6 xl:col-span-5 z-10 col-start-1 px-3 pb-6 lg:col-start-2 xl:col-start-2 lg:my-16  lg:p-12 bg-white/[0.8]",
      imagesContainer:
        "col-span-12  order-first lg:order-none lg:absolute top-0 left-0 right-0 bottom-0",
    },
    tabContentContainer:
      classes?.tabContentContainer ||
      "col-span-12 md:col-span-10 md:col-start-2  relative",
    counterContainer: classes?.counterContainer || "bg-transparent",
    counter: classes?.counter || {
      counter: "hidden",
      prev: "absolute left-3 lg:left-12 top-1/2  xl:top-[60%] hidden lg:block",
      next: "absolute right-3 lg:right-12 top-1/2 xl:top-[60%] hidden lg:block",
    },
  };
  return (
    <div className={classNames(styles?.container)}>
      <div className={classNames(styles?.tabsItemsContainer)}>
        <div className={classNames({ "hidden lg:block": type })}>
          <TabItems
            tabs={tabs}
            onSelect={onSelect}
            classes={styles?.tabs}
            active={active}
          />
        </div>
        {type === "select" ? (
          <div className="lg:hidden">
            <DropdownTabs
              tabs={tabs}
              onSelect={onSelect}
              classes={classes?.dropdown}
              active={active}
              arrow={arrow}
            />
          </div>
        ) : (
          ""
        )}
        {type === "slider" ? (
          <div className="lg:hidden">
            <TabSlider
              tab={tabs[active] || {}}
              classes={styles?.tabs}
              active={active + 1}
              to={tabs?.length || "0"}
              onChange={onChange}
              arrowPrev={arrowPrevSlider}
              arrowNext={arrowNextSlider}
            />
          </div>
        ) : (
          ""
        )}
      </div>
      <div className={classNames(styles?.tabContentContainer)}>
        <Swiper
          ref={sliderRef}
          pagination={{ clickeable: true }}
          modules={[Pagination]}
          initialSlide={active}
          spaceBetween={20}
          onSlideChange={(swiper) => {
            setActive(swiper.activeIndex);
          }}
          className="slider-tabs "
        >
          {tabs?.map((tab, key) => {
            return (
              <SwiperSlide key={key}>
                <TabContent tab={tab} classes={styles?.tabContent} />
              </SwiperSlide>
            );
          })}
        </Swiper>
      </div>

      {counter && tabs.length ? (
        <div className={classNames(styles?.counterContainer)}>
          <CounterTabs
            classes={styles?.counter}
            active={active + 1}
            to={tabs?.length || "0"}
            onChange={onChange}
            arrowPrev={arrowPrev}
            arrowNext={arrowNext}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
};
export default TabsSlider;
